import { connect } from "react-redux";
import { compose } from "redux";
import DialoguePageTopic from "../components/dialogue-page-topic";
import { getVariables } from "../utilities/route";
import { withData } from "../decorators/with-data";
import gql from "graphql-tag";
import { withTranslations } from "../decorators/with-translations";
import { setSubmitError } from "../actions/survey";
import { QUESTIONNAIRE_FRAGMENT } from "../graphql/fragments";
import { withImprovementProjectData } from './withImprovementProjectData'

export const query = gql`
  query DiscussionPage(
    $surveyId: UUID!
    $topicId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    afterGameDialogueTopic(
      surveyId: $surveyId,
      topicId: $topicId,
      languageCode: $languageCode
    ) {
      id
      title
      questionsCount
      active
      questions {
        id
        title
        answersCount
        active
        comments {
          id
          likesCount
          text
          createdAt
          respondentColor
          hasLikeByThisRespondent
          authorRespondentId
          isOwnedByThisRespondent
          replies {
            id
            likesCount
            text
            createdAt
            respondentColor
            hasLikeByThisRespondent
            authorRespondentId
            isOwnedByThisRespondent
          }
        }
        image
      }
      tips {
        id
        text
      }
      image
    }
    afterGameDialogueTopics(
      surveyId: $surveyId,
      languageCode: $languageCode
    ) {
      id
      title
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;


const mapStateToProps = ({ survey: { submitError } }) => {
  return {
    submitError,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    },
  };
};

export default compose(
  withTranslations,
  withData(query, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "cache-and-network",
      };
    },
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withImprovementProjectData,
)(DialoguePageTopic);



// WEBPACK FOOTER //
// ./src/containers/dialogue-page-topic.js